import { CurrentProducts } from './sections';
import { MyProductsHeader } from './sections';

export function MyProducts() {
  return (
    <div className="flex flex-col gap-8">
      <MyProductsHeader />
      <CurrentProducts />
    </div>
  );
}
